import { Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AddressBookRecord } from '@tassat/payments-definitions';
import React from 'react';

import FavoriteMenu from 'SharedComponents/actionsDropdownMenu/favoriteMenu';

interface IsFavoriteCellRendererProps {
    data: AddressBookRecord;
    onContactFavoriteChange: (data: AddressBookRecord) => unknown;
}

const muiStyles = makeStyles({
    root: {
        whiteSpace: 'normal',
        minHeight: '100%'
    }
});

const IsFavoriteCellRenderer = (props: IsFavoriteCellRendererProps) => {
    const { data } = props;

    const { root } = muiStyles(props);

    const onFavoriteChange = (): void => {
        props.onContactFavoriteChange(data);
    };

    return (
        <Grid
            alignItems='center'
            className={root}
            container
            direction='column'
            justifyContent='center'
            spacing={0}
        >
            <FavoriteMenu
                isFavorited={data.IsFavorite}
                onChange={onFavoriteChange}
            />
        </Grid>
    );
};

export default IsFavoriteCellRenderer;